/*
 * @Author: M.D.
 * @Date: 2020-01-10 13:39:18
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 */
import request from './axios'
import request1 from './axios1'
// import _ from 'lodash'

export default {

  //全电单点登录
  qdyjdl: data => {
    return request({
      url: '/order/com/qddddl',
      method: 'POST',
      data
    })
  },



  //获取用户名称
  getQymc: data => {
    return request({
      url: '/order/com/getQymc',
      method: 'POST',
      data
    })
  },


}
